import { render, staticRenderFns } from "./BulkSendTemplateEnvelopesCardTable.vue?vue&type=template&id=13482e21&lang=pug"
import script from "./BulkSendTemplateEnvelopesCardTable.vue?vue&type=script&lang=js"
export * from "./BulkSendTemplateEnvelopesCardTable.vue?vue&type=script&lang=js"
import style0 from "./BulkSendTemplateEnvelopesCardTable.vue?vue&type=style&index=0&id=13482e21&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports